import React from 'react'

const Estructuras = () => (
    <h1>Bienvenido a Estructura</h1>
);


export default Estructuras;